<template>
	<div>
		<el-dialog class="custom-dialog todo-detail-dialog" append-to-body destroy-on-close :visible.sync="isSidebarActiveLocal">
			<div slot="title" class="w-full">
				<span class="el-dialog__title break-normal">{{ $t("CHI TIẾT AO NUÔI") }}</span>
				<p class="text-base font-medium">Khu/Ao: {{data.zone ? `${data.zone} - ` : ''}}{{ data.name }}</p>
			</div>
			<div>
				<el-radio-group v-model="tabPosition" class="w-full flex">
					<el-radio-button class="flex-1" label="in">Thông tin đầu vào</el-radio-button>
					<el-radio-button class="flex-1" label="feed">Thông tin nuôi</el-radio-button>
					<el-radio-button class="flex-1" label="out">Thông tin thu hoạch</el-radio-button>
				</el-radio-group>
				<div class="p-6" v-if="data">
					<div v-if="tabPosition === 'in'">
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Ngày thả") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.stocking.data && data.stocking.data[0] && data.stocking.data[0].datetime ? $helper.momentFormat(data.stocking.data[0].datetime, 'DD/MM/YYYY') : "" }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Số lượng thả") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ $helper.numFormat(quantityPerIndividual(data.stocking.data)) }} con</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Khối lượng thả") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ $helper.numFormat(quantityPerKg(data.stocking.data)) }} kg</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Mẫu thả (con/kg)") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ sizes(data.stocking.data) }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Diện tích") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ $helper.numFormat(data.area) }} m<sup>2</sup></vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Mật độ") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black" v-if="quantityPerIndividual(data.stocking.data) > 0">
								{{ $helper.numFormat(quantityPerIndividual(data.stocking.data)/data.area||1) }} con / m<sup>2</sup>
							</vs-col>
						</vs-row>

						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">Kỹ thuật phụ trách:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">
								<ViewAssigned :key="data.assignedTo._id + data._id" :assignedTo="data.assignedTo || null" :customer="getCustomer(data)" :pondId="data ? data._id : null" />
							</vs-col>
						</vs-row>

					</div>
					<div v-else-if="tabPosition === 'feed'">
						<vs-row class="mb-1" v-if="data.lastUpdatedOverview">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">Lũy tiến đến ngày:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ $helper.momentFormat(data.lastUpdatedOverview) }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Tổng lượng thức ăn") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.feeding && data.feeding.overview ? $helper.numFormat(data.feeding.overview.totalQty) : "" }} kg</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Tổng hao hụt (con)") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.fishLoss && data.fishLoss.overview ? $helper.numFormat(data.fishLoss.overview.totalQtyPerIndividual) : "" }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Tổng hao hụt (kg)") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.fishLoss && data.fishLoss.overview ? $helper.numFormat(data.fishLoss.overview.totalQtyPerKg) : "" }}</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Trọng lượng bình quân") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.fishGrow && data.fishGrow.overview ? $helper.numFormat(data.fishGrow.overview.weight) : "" }} gr</vs-col>
						</vs-row>
						<vs-row class="mb-1">
							<vs-col vs-w="4">
								<label class="text-solid-gray-1">{{ $t("Sản lượng cá ước lượng") }}:</label>
							</vs-col>
							<vs-col vs-w="8" class="text-black">{{ data.fishGrow && data.fishGrow.overview ? $helper.numFormat(data.fishGrow.overview.estYield) : "" }} kg</vs-col>
						</vs-row>
					</div>
					<div v-else>
						<div class="" v-if="data.harvests && data.harvests.ponds">
							<div :key="pond._id" v-for="pond in data.harvests.ponds.reverse()">
								<div class="grid grid-cols-2 pb-2">
									<!-- Thông tin vào -->
									<div class="border-solid border border-gray-5 rounded-md m-1 p-4">
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Ngày thả") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.stocking.data && pond.stocking.data[0] ? $helper.momentFormat(pond.stocking.data[0].datetime, 'DD/MM/YYYY') : "" }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Số lượng thả") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ $helper.numFormat(quantityPerIndividual(pond.stocking.data)) }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Khối lượng thả") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ $helper.numFormat(quantityPerKg(pond.stocking.data)) }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Mẫu thả (con/kg)") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.stocking.data ? sizes(pond.stocking.data) : "" }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Diện tích") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ $helper.numFormat(data.area) }} m<sup>2</sup></vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Mật độ") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black" v-if="quantityPerIndividual(pond.stocking.data) > 0"
												>{{ $helper.numFormat(quantityPerIndividual(pond.stocking.data)/data.area) }} con / m<sup>2</sup></vs-col
											>
										</vs-row>
									</div>
									<!-- Thông tin thu hoạch -->
									<div class="border-solid border border-gray-5 rounded-md m-1 p-4">
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Ngày thu hoạch") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.harvest ? $helper.momentFormat(pond.harvest.begin) : "" }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Cỡ cá thu hoạch") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.fishGrow && pond.fishGrow.overview ? $helper.numFormat(pond.fishGrow.overview.weight) : "" }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Sản lượng") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.harvest ? $helper.numFormat(pond.harvest.weight) : "" }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Giá bán") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.harvest ? $helper.numFormat(pond.harvest.price) : "" }} đ/kg</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Thời gian nuôi") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.harvest ? caculateDaysBetween(pond.harvest.begin, pond.stocking && pond.stocking.data && pond.stocking.data[0] ? pond.stocking.data[0].datetime : pond.harvest.begin) + " ngày" : "" }} </vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("Loại thực ăn") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.usingFeedBrand }}</vs-col>
										</vs-row>
										<vs-row class="my-2">
											<vs-col vs-w="6">
												<label class="text-solid-gray-1">{{ $t("FCR") }}:</label>
											</vs-col>
											<vs-col vs-w="6" class="text-black">{{ pond.harvest ? pond.harvest.fcr : "" }}</vs-col>
										</vs-row>
									</div>
								</div>
								<vs-divider />
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import moment from "moment";
import ViewAssigned from "@/components/view-assigned/ViewAssigned";
moment.locale("vi");
export default {
	components: {ViewAssigned},
	name: "PondDetail",
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},

	data() {
		return {
			tabPosition: "in"
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				console.log("PondDetail", this.data);

				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		}
	},
	methods: {
		getCustomer(data) {
			let customer = {};
			if (data) {
				if (data.customer) customer = data.customer;
				if (data.assignedTo) customer.assignedTo = data.assignedTo;
			}
			return customer;
		},
		quantityPerIndividual(data) {
			let total = 0;
			data.map(item => {
				total = total + item.quantityPerIndividual;
			});
			return total;
		},
		quantityPerKg(data) {
			let total = 0;
			data.map(item => {
				total = total + item.quantityPerKg;
			});
			return total;
		},
		sizes(data) {
			let sizes = "";
			data.map(item => {
				sizes += item.size ? `${item.size}; ` : '';
			});
			sizes = sizes.slice(0, sizes.lastIndexOf(";"));

			return sizes;
		},
		caculateDaysBetween(begin, datetime) {
			const start = moment(begin, "YYYY-MM-DD");
			const end = moment(datetime, "YYYY-MM-DD");
			return moment.duration(start.diff(end)).asDays();
		}
	}
};
</script>
<style lang="scss">
.el-radio-button__inner {
	width: 100%;
	border: none;
	border-radius: 0 0 0 0 !important;
}
[dir] .el-radio-button__inner {
	background: #e0e0e0;
}
</style>
